import { render } from "./testTable.vue?vue&type=template&id=4acaf1b0"
import script from "./testTable.vue?vue&type=script&lang=js"
export * from "./testTable.vue?vue&type=script&lang=js"

import "./testTable.vue?vue&type=style&index=0&id=4acaf1b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__